/**
 * External Imports
 */
import { FC, useState } from 'react';

/**
 * Internal Imports
 */
import SideNav from '../../components/sideNav/adminSideNav/AdminSideNav';
import UnitsTable from '../../components/customTables/admin/areasTable/UnitsTable';

/**
 * Style Imports
 */
import {
  AreasContainer,
  AreasContainerInner
} from './styles/AdminViews.styles';

const menuItems = [
  { tabLabel: 'Units', tabId: 'units' }
  // { tabLabel: 'Departments', tabId: 'departments' }
];

const Areas: FC = () => {
  const [selectedTab, setSelectedTab] = useState<string>('units');
  return (
    <AreasContainer id="Admin-Area-List">
      <SideNav
        navItems={menuItems}
        selectedTab={selectedTab}
        setSelectedTab={setSelectedTab}
      />
      <AreasContainerInner>
        {selectedTab && selectedTab === 'units' && <UnitsTable />}
        {/* {selectedTab && selectedTab === 'departments' && <DepartmentsTable />} */}
      </AreasContainerInner>
    </AreasContainer>
  );
};

export default Areas;
